var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Text } from "./";
import Icon from "./Icon";
import ProductPriceRow from "./ProductPriceRow";
import React from 'react';
import { css, styled } from "../utils";
var CHECKED_TEXT = 'Ausgewählt';
var ProductContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: pointer;\n"], ["\n  cursor: pointer;\n"])));
var ProductPreview = styled.div(function (_a) {
    var selected = _a.selected, name = _a.name, colors = _a.theme.colors;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: 100%;\n    box-sizing: border-box;\n    display: flex;\n    overflow: hidden;\n    position: relative;\n    border: ", ";\n    .", "-hover:hover {\n      opacity: 1;\n    }\n    aspect-ratio: 4 / 3;\n  "], ["\n    width: 100%;\n    box-sizing: border-box;\n    display: flex;\n    overflow: hidden;\n    position: relative;\n    border: ", ";\n    .", "-hover:hover {\n      opacity: 1;\n    }\n    aspect-ratio: 4 / 3;\n  "])), selected ? "solid 3px ".concat(colors.primary) : 'none', name.split(' ').join('-'));
});
var CheckedOval = styled.div(function (_a) {
    var _b = _a.theme, radii = _b.radii, colors = _b.colors;
    return ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-evenly',
        position: 'absolute',
        width: '125px',
        height: '25px',
        borderRadius: radii[0],
        backgroundColor: colors.secondary,
        bottom: '5%',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 2,
    });
});
var ProductImage = styled.div(function (_a) {
    var image = _a.image, zoomTransition = _a.zoomTransition;
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    flex: 1;\n    background: url(", ") center center / cover no-repeat;\n    transition: transform ease-in-out 0.3s;\n  "], ["\n    ", "\n\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    flex: 1;\n    background: url(", ") center center / cover no-repeat;\n    transition: transform ease-in-out 0.3s;\n  "])), zoomTransition && '&:hover { transform: scale(1.125); }', image);
});
var HoverImage = styled.div(function (_a) {
    var hoverImage = _a.hoverImage;
    return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    &:hover {\n      opacity: 1;\n    }\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    flex: 1;\n    opacity: 0;\n    background: url(", ") center center / cover no-repeat;\n    transition: opacity 0.3s ease-in-out;\n  "], ["\n    &:hover {\n      opacity: 1;\n    }\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    flex: 1;\n    opacity: 0;\n    background: url(", ") center center / cover no-repeat;\n    transition: opacity 0.3s ease-in-out;\n  "])), hoverImage);
});
var ProductListItem = function (_a) {
    var name = _a.name, image = _a.image, price = _a.price, onClick = _a.onClick, _b = _a.selected, selected = _b === void 0 ? false : _b, hoverImage = _a.hoverImage;
    return (React.createElement(ProductContainer, { onClick: onClick },
        React.createElement(ProductPreview, { selected: selected, name: name },
            selected && (React.createElement(CheckedOval, { className: "checked" },
                React.createElement(Text, null, CHECKED_TEXT),
                " ",
                React.createElement(Icon.GreenCheck, { width: "12px", height: "12px" }))),
            React.createElement(ProductImage, { image: image, zoomTransition: !hoverImage }),
            hoverImage && (React.createElement(HoverImage, { className: "".concat(name.split(' ').join('-'), "-hover"), hoverImage: hoverImage }))),
        React.createElement(ProductPriceRow, { label: name, value: price })));
};
export default ProductListItem;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=ProductListItem.js.map